/* eslint-disable react/prop-types */
import React from 'react';

import {Get} from '@/api/request';
import {STEP_WIZARD, POOLING_PARAM_LABEL} from '@/constants/calibrationWizardConstant';
import * as APPDATA from '@/constants/pcConstAppData';
import {CalibrationScaleEvent} from '@/constants/pubSubEnum';
import {consoleError} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import CalibrationStep from '../components/CalibrationStep';

const ViewValue = {
  FIELD_A: APPDATA.KEY.ProteinSensor,
  FIELD_B: APPDATA.KEY.ProteinReference,
  FIELD_C: APPDATA.KEY.BufferSensor,
  FIELD_D: APPDATA.KEY.BufferReference,
};

const ResetField = {
  [ViewValue.FIELD_A]: APPDATA.EMPTY_FIELD,
  [ViewValue.FIELD_B]: APPDATA.EMPTY_FIELD,
  [ViewValue.FIELD_C]: APPDATA.EMPTY_FIELD,
  [ViewValue.FIELD_D]: APPDATA.EMPTY_FIELD,
};

class PoolingSamplingData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calibrationTubeVolume: {
        [APPDATA.KEY.BufferSensor]: '-1',
        [APPDATA.KEY.BufferReference]: '-1',
        [APPDATA.KEY.ProteinSensor]: '-1',
        [APPDATA.KEY.ProteinReference]: '-1',
      },
      viewValue: ResetField,
      isEnableButton: true,
    };

    this.mounted = true;
    this._bus = eventBusObject();
    this.subscriptSetMenuUncomplate = this._bus.subscribe(CalibrationScaleEvent.SET_TOP_MENU_UNCOMPLATE, (param) =>
      this.uncomplateAction(param),
    );
    this.subscriptSetMenuComplate = this._bus.subscribe(CalibrationScaleEvent.SET_TOP_MENU_COMPLATE, (param) =>
      this.completeAction(param),
    );

    this.setLoadCellVolumeSensor = this.setLoadCellVolumeSensor.bind(this);
  }

  // this DId mount is calling twice when  rendered
  componentDidMount() {
    const {calibrationTubeVolume} = this.props;

    this.mounted = true;
    this.setTopMenuAttribute(true);

    this.setState({
      isEnableButton: true,
      viewValue: {
        [APPDATA.KEY.BufferSensor]: APPDATA.EMPTY_FIELD,
        [APPDATA.KEY.BufferReference]: APPDATA.EMPTY_FIELD,
        [APPDATA.KEY.ProteinSensor]: APPDATA.EMPTY_FIELD,
        [APPDATA.KEY.ProteinReference]: APPDATA.EMPTY_FIELD,
      },
      calibrationTubeVolume,
    });

    this._poolingCapacitance = setInterval(() => {
      this.getLoadCellVolumeSensor();
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  }

  componentWillUnmount() {
    this.subscriptSetMenuComplate.unsubscribe();
    this.subscriptSetMenuUncomplate.unsubscribe();

    this.mounted = false;

    if (typeof this._poolingCapacitance !== 'undefined') {
      clearInterval(this._poolingCapacitance);
      this._poolingCapacitance = undefined;
    }
  }

  getLoadCellVolumeSensor = () => {
    if (this.mounted === true) {
      Get(APPDATA.API.GET_ALL_SENSOR_VALUE, '', this.setLoadCellVolumeSensor);
    }
  };

  setLoadCellVolumeSensor = (response) => {
    const {calibrationTubeVolume, viewValue} = this.state;

    if (this.mounted === true) {
      const newViewValue = viewValue;

      if (calibrationTubeVolume[APPDATA.KEY.ProteinReference] !== -1) {
        newViewValue[APPDATA.KEY.ProteinReference] = calibrationTubeVolume[APPDATA.KEY.ProteinReference];
      }

      if (calibrationTubeVolume[APPDATA.KEY.BufferReference] !== -1) {
        newViewValue[APPDATA.KEY.BufferReference] = calibrationTubeVolume[APPDATA.KEY.BufferReference];
      }

      newViewValue[APPDATA.KEY.ProteinSensor] = response.data.VolumeSensor.sensor0;
      newViewValue[APPDATA.KEY.BufferSensor] = response.data.VolumeSensor.sensor2;

      this.setState({
        viewValue: newViewValue,
      });
    }
  };

  saveInputRef = (refWeight) => {
    const {calibrationStep} = this.props;
    const {calibrationTubeVolume} = this.state;

    const newCalibrationTubeVolume = calibrationTubeVolume;

    switch (calibrationStep) {
      case STEP_WIZARD.NoTubeCalibration:
        break;
      case STEP_WIZARD.SampleTubeCalibration:
        newCalibrationTubeVolume[APPDATA.KEY.ProteinReference] = refWeight;
        newCalibrationTubeVolume[APPDATA.KEY.BufferReference] = refWeight;
        break;
      case STEP_WIZARD.BufferTubeCalibration:
        break;
      default:
        consoleError('Calibration step is undefined');
        break;
    }

    if (this.mounted === true) {
      this.setState({
        calibrationTubeVolume: newCalibrationTubeVolume,
      });
    }

    if (this.mounted === true) {
      this.setState({
        isEnableButton: true,
      });
    }
  };

  saveOnClick = () => {
    const {calibrationStep, saveAction} = this.props;
    const {calibrationTubeVolume} = this.state;

    saveAction(calibrationTubeVolume, calibrationStep);
  };

  completeAction = (currentStep) => {
    const {calibrationStep} = this.props;

    if (calibrationStep === currentStep) {
      this.setState({
        isEnableButton: true,
      });

      this.setTopMenuAttribute(false);
    }
  };

  uncomplateAction = (param) => {
    const {calibrationStep} = this.props;

    const {EnableButton, currentStep} = param;

    if (calibrationStep === currentStep) {
      if (EnableButton === 'ENABLE') {
        this.setState({
          isEnableButton: true,
        });
      } else {
        this.setState({
          isEnableButton: false,
        });
      }

      this.setTopMenuAttribute(true);
    }
  };

  setTopMenuAttribute = (disableButtonNext) => {
    const {isRecalibration, nextAction, backAction} = this.props;

    const topButtonProperties = {
      id: APPDATA.NEXT,
      label: APPDATA.NEXT,
      onClick: nextAction,
      disabled: disableButtonNext,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: !!isRecalibration,
      onClick: backAction,
    };

    const titleMenuProperties = APPDATA.CALIBRATION_LOAD_CELL_CALIBRATE_SCALE;

    this._bus.publish(CalibrationScaleEvent.SET_TOP_MENU, {
      topButtonProperties,
      backButtonProperties,
      titleMenuProperties,
    });
  };

  render() {
    const {params, calibrationStep} = this.props;
    const {viewValue, isEnableButton} = this.state;

    return (
      <CalibrationStep
        imageSrc={params[POOLING_PARAM_LABEL.IMAGES]}
        saveRefAction={this.saveInputRef}
        saveAction={this.saveOnClick}
        disableSaveButton={!isEnableButton}
        calibrationStep={calibrationStep}
        text={params[POOLING_PARAM_LABEL.TEXT]}
        parameter={[
          {
            label: params[POOLING_PARAM_LABEL.FIELD_LABEL][0],
            value: viewValue[ViewValue.FIELD_A],
            unit: params[POOLING_PARAM_LABEL.TEXT][1],
          },
          {
            label: params[POOLING_PARAM_LABEL.FIELD_LABEL][1],
            value: viewValue[ViewValue.FIELD_B],
            unit: params[POOLING_PARAM_LABEL.TEXT][1],
          },
          {
            label: params[POOLING_PARAM_LABEL.FIELD_LABEL][2],
            value: viewValue[ViewValue.FIELD_C],
            unit: params[POOLING_PARAM_LABEL.TEXT][1],
          },
          {
            label: params[POOLING_PARAM_LABEL.FIELD_LABEL][3],
            value: viewValue[ViewValue.FIELD_D],
            unit: params[POOLING_PARAM_LABEL.TEXT][1],
          },
        ]}
      />
    );
  }
}
export default PoolingSamplingData;
